import { Alert, Button, Stack, Typography } from "@mui/material";
import { format } from "date-fns";
import OrderSummary from "./OrderSummary";
import WushCard from "../../layout/WushCard";
import { useNavigate } from "react-router-dom";
import WushPopover from "../../layout/WushPopover";
import OrderRefundForm from "../../form/orders/OrderRefundForm";
import OrderRefunds from "./OrderRefunds";
import { useState } from "react";
import update from "../../../api/auth/orders/update";
import useOrderStore from "../../../stores/useOrderStore";
import DeleteConfirmation from "../../form/DeleteConfirmation";
import { Delete } from "@mui/icons-material";
import destroy from "../../../api/auth/orders/destroy";
import useAlertStore from "../../../stores/useAlertStore";

const CustomerPaidAlert = ({ order }) => {
  if(order.payment_type === 'cash') return (
    <Alert severity="info">Customer paid <b>${order.total_price_with_fees_dollars}</b> in cash on {format(new Date(order.payment_confirmed_at), 'MM/dd/yyyy @ hh:mm aa')}</Alert>
  );
  if(order.payment_type === 'stripe') return (
    <Alert severity="info">Customer paid <b>${order.payment_intent_amount_received_dollars}</b> with card via Stripe on {format(new Date(order.payment_confirmed_at), 'MM/dd/yyyy @ hh:mm aa')}</Alert>
  );
};

export default function OrderReview({ order }) {
  const [refundPopoverClosed, setRefundPopoverClosed] = useState(false);
  const navigate = useNavigate();

  const { updateOrder, removeOrder } = useOrderStore();
  const { setAlertMessage } = useAlertStore();

  const handleCancel = () => {
    update(order.id, { status: 'cancelled' }, (response) => {
      updateOrder(response);
    });
  };

  const handleDelete = () => {
    destroy(order.id, () => {
      removeOrder(order);
      setAlertMessage('Order deleted successfully');
      navigate('/orders');
    });
  };

  return (
    <Stack gap={2}>
      <Stack direction="row" className="hide-print">
        <Button onClick={() => navigate('/orders')}>
          Back to Orders
        </Button>
      </Stack>
      <Stack className="hide-print">
        <Typography variant="h3">Order #{order.id}</Typography>
      </Stack>
      <Stack>
        <CustomerPaidAlert order={order} />
      </Stack>
      <Stack direction="row" className="hide-print" spacing={2}>
        <Button onClick={() => window.print()} variant="contained">
          Print
        </Button>
        {order.payment_intent_succeeded_at && <WushPopover
          anchor={
            <Button variant="outlined">
              Create Refund
            </Button>
          }
          forceClose={refundPopoverClosed}
        >
          <Stack p={2}>
            <OrderRefundForm
              order={order}
              afterCreate={() => {
                setRefundPopoverClosed(true);
                setInterval(() => setRefundPopoverClosed(false), 100);
              }}
            />
          </Stack>
        </WushPopover>}
        {order.status !== 'cancelled' && <DeleteConfirmation
          handleDelete={handleCancel}
          title="Are you sure you want to cancel this order?"
          ctaText="Cancel Order"
          cancelCtaText={"Nevermind"}
        >
          <Button variant="contained" color="error">
            Cancel Order
          </Button>
        </DeleteConfirmation>}
        {order.deletable && <Stack direction="row" mb={2}>
          <DeleteConfirmation
            handleDelete={handleDelete}
          >
            <Button variant="contained" color="error">
              <Stack direction="row" spacing={1}>
                <Delete />
                <Typography>Delete Order</Typography>
              </Stack>
            </Button>
          </DeleteConfirmation>
        </Stack>}
      </Stack>
      <Stack>
        <WushCard>
          <Stack p={2}>
            <OrderSummary order={order} />
          </Stack>
        </WushCard>
      </Stack>
      <Stack>
        <OrderRefunds order={order} />
      </Stack>
    </Stack>
  );
}